import HistoryGraph from './HistoryGraph';

const History = () => <HistoryGraph />;

export default History;
